import {
  CtmAnalyticsQuery,
  CtmAnalyticsModel,
} from '../model/CtmAnalyticsModel';
import { CtmInsightsController } from '../controllers/CtmInsightsController';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { permissionsHandler } from '../errorHandlers/common-handler';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class CtmInsightsCRUDActions extends CrudActionContainer {
  retrieveForQueryAction: string;

  constructor() {
    super('CTM_INSIGHTS');
    this.retrieveForQueryAction = super.makeActionKey('RETRIEVE_FOR_QUERY');
  }

  retrieveForQuery(botId: number, query: CtmAnalyticsQuery) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.retrieveForQueryAction));
        const response = await CtmInsightsController.retrieve(botId, query);
        dispatch(this.retrieveByQueryActionCreator(response, query));
        return response;
      } catch (e) {
        dispatch(this.unbusy());
        return permissionsHandler(dispatch, this)(e);
      }
    };
  }

  retrieveByQueryActionCreator(
    results: {
      data: CtmAnalyticsModel[];
      next: string | null;
      prev: string | null;
    },
    query: CtmAnalyticsQuery,
  ) {
    return {
      type: this.retrieveForQueryAction,
      results,
      query,
    };
  }
}

const ctmInsightsCRUDActions = new CtmInsightsCRUDActions();

export const useCtmInsightsCRUDActions = getActionHookBuilder(
  ctmInsightsCRUDActions,
  ['retrieveForQuery'],
);

export default ctmInsightsCRUDActions;
